export enum CourseOfferType {
  OTS_FREE_LIVE = 'OTS_FREE_LIVE',
  OTS_LIVE = 'OTS_LIVE',
  OTS_DEVELOPMENT = 'OTS_DEVELOPMENT',
  ENTERPRISE_LIVE = 'ENTERPRISE_LIVE',
  ENTERPRISE_DEVELOPMENT = 'ENTERPRISE_DEVELOPMENT',
  SANDBOX = 'SANDBOX',
  IMPORTED_CUSTOM_COURSE = 'IMPORTED_CUSTOM_COURSE',
}
